module.exports = __webpack_public_path__ + "img/digest1.e2d090ea.svg";